import React from 'react'

function RolesHead() {
    return <thead className="TableHead">
    <tr>
        <th className="bulkActions">STT</th>
        <th className="colItem">Khách hàng</th>
        <th className="colItem">Tên quyền</th>
    </tr>
    </thead>
}

export default RolesHead
